import React from 'react';
import {
  graphql,
  createRefetchContainer,
} from 'react-relay';

import { withRouter } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import { Link } from '@material-ui/core';
import { useCommonStyles } from '../common/Styles';
import TableFieldMeta from '../../common/TableFieldMeta';
import InnerTabFilterGridItemTextField from '../common/innerTab/InnerTabFilterGridItemTextField';
import BaseGridContainer from '../common/BaseGridContainer';
import InnerTabFilterGridItemDateField from '../common/innerTab/InnerTabFilterGridItemDateField';
import TableStatus from '../common/TableStatus';
import TablePaginator from '../common/TablePaginator';
import { createQueryRendererProgressV2 } from '../common/QueryRendererProgressV2';
import MsgRouter from '../../common/MsgRouter';
import InnerTabFilterToggleButtonGroup from '../common/innerTab/InnerTabFilterToggleButtonGroup';
import RTTableRenderer from '../common/table/RTTableRenderer';
import BrokerActivityTableFieldMeta from '../activityIB/BrokerActivityTableFieldMeta';
import BrokerTransactionTableFieldMeta from '../activityIB/BrokerTransactionTableFieldMeta';
import BrokerActivityActions from '../activityIB/BrokerActivityActions';
import BrokerTransactionActions from '../activityIB/BrokerTransactionActions';
import BrokerTransactionDetails from '../activity/BrokerTransactionDetails';
import SettledTxnSelectionCell from './settledTransaction/SettledTxnSelectionCell';
import { AddButton } from '../common/buttons/BaseButton';
import { doCommitPromise } from '../../common/commit';
import createClearstreamCashTransferPreAdviseFile
  from '../../mutations/clearstream/CreateClearstreamCashTransferPreAdviseFile';
import { deepCoalesce } from '../../common/helpers';

const matchedDefault = false;
const ignoreDefault = false;

function CSSettledTransactionList(props) {
  const { viewer, relay, filter } = props;
  filter.setRelay(relay);
  const classes = useCommonStyles();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [detailsOpen, setDetailsOpen] = React.useState(false);
  const [brokerActivity, setBrokerActivity] = React.useState(null);
  const [msgRouter] = React.useState(new MsgRouter());
  const [selectionSet, setSelectionSet] = React.useState([]);
  const columns = [
    TableFieldMeta.localId,
    TableFieldMeta.field('quantity', 'Quantity', { align: 'right', width: 120 }),
    BrokerActivityTableFieldMeta.currency,
    TableFieldMeta.field('proceeds', 'Proceeds', { align: 'right', width: 180 }),
    TableFieldMeta.field('settledAmount', 'Settled Amount', { align: 'right', width: 180 }),
    TableFieldMeta.field('price', 'Price', { align: 'right', width: 80 }),
    BrokerActivityTableFieldMeta.reportDate,
    TableFieldMeta.field(node => (node.matched
      ? <TableStatus primary>Match</TableStatus>
      : <TableStatus secondary>Unmatch</TableStatus>
    ), 'Matched'),
    TableFieldMeta.field(node => (node.ignore
      ? <TableStatus>Ignore</TableStatus>
      : <TableStatus secondary>UnIgnore</TableStatus>
    ), 'Ignored'),
    TableFieldMeta.createdAt,
    TableFieldMeta.fieldCell('selection', '', row => (
      <SettledTxnSelectionCell
        pendingTransaction={row.value}
        selectionSet={selectionSet}
        setSelectionSet={setSelectionSet}
      />
    ), { align: 'center', width: 50, accessor: x => x }),
    TableFieldMeta.fieldCell('paFile', 'Pre Advise File', (row) => {
      const paFile = deepCoalesce(row.value, ['brokerOrder', 'csbrokerorder', 'transferAdviceFile']);
      if (!paFile) {
        return null;
      }
      return <Link href={paFile.csvUrl}>{paFile.csv.split('/')[2]}</Link>;
    }, { accessor: x => x, width: 200, align: 'center' }),
    BrokerTransactionTableFieldMeta.ignore,
    {
      id: 'details',
      accessor: node => node,
      Header: 'Details',
      Cell: row => (
        <BrokerActivityActions
          brokerActivity={row.value}
          isProcessed={x => x.matched}
          isIgnored={x => x.ignore}
          showProcess={false}
          onProcess={(be) => {
            // setBrokerActivity(be);
            // setDrawerOpen(true);
          }}
          onShowDetails={(be) => {
            setBrokerActivity(be);
            setDetailsOpen(true);
          }}
        />
      ),
    },
    TableFieldMeta.fieldCell('actions', 'Actions', row => (
      <BrokerTransactionActions
        msgRouter={msgRouter}
        brokerTransaction={row.original}
        isProcessed={x => x.matched}
        isIgnored={x => x.ignore}
        onProcess={(be) => {
          // setBrokerActivity(be);
          // setDrawerOpen(true);
        }}
        onShowDetails={(be) => {
          setBrokerActivity(be);
          setDetailsOpen(true);
        }}
      />
    )),
  ];

  return (
    <div className={classes.innerTabRoot}>
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <div
          tabIndex={0}
          role="button"
        >
          {/*<ProcessForm brokerActivity={brokerActivity} close={() => setDrawerOpen(false)} />*/}
        </div>
      </Drawer>

      <Drawer anchor="right" open={detailsOpen} onClose={() => setDetailsOpen(false)}>
        <div
          tabIndex={0}
          role="button"
        >
          <div className={classes.drawerRootExtended}>
            <BrokerTransactionDetails
              brokerTransactionId={brokerActivity && brokerActivity.brokertransactionPtr.id}
            />
          </div>
        </div>
      </Drawer>

      <BaseGridContainer>
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <InnerTabFilterGridItemTextField
              id="search-filter"
              label="Custom Search"
              defaultValue={filter.params.search}
              helperText="description, symbol"
              onChange={e => filter.updateVar('search', e.target.value)}
            />

            <InnerTabFilterGridItemDateField
              value={filter.params.reportDate}
              onChange={value => filter.updateVar('reportDate', value)}
              label="Report Date"
            />

            <InnerTabFilterToggleButtonGroup
              enumType={[
                { name: null, description: '∅' },
                { name: true, description: 'Yes' },
                { name: false, description: 'No' },
              ]}
              helperText="Matched?"
              defaultValue={filter.params.matched}
              onChange={newVal => filter.updateVar('matched', newVal)}
            />

            <InnerTabFilterToggleButtonGroup
              enumType={[
                { name: null, description: '∅' },
                { name: true, description: 'Yes' },
                { name: false, description: 'No' },
              ]}
              helperText="Ignored?"
              defaultValue={filter.params.ignore}
              onChange={newVal => filter.updateVar('ignore', newVal)}
            />


          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <AddButton
                disabled={selectionSet.length === 0}
                buttonText="Pre Advised File"
                onClickPromise={() => doCommitPromise(
                  createClearstreamCashTransferPreAdviseFile,
                  { settledTransactionIds: selectionSet.map(x => x.id) },
                  () => {
                    filter.update();
                    setSelectionSet([]);
                  },
                  () => null,
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <TablePaginator
            filter={filter}
            columns={columns}
            getDataNode={() => (viewer ? viewer.clearstreamSettledTransactions : null)}
            tableRender={RTTableRenderer}
          />
        </Grid>
      </BaseGridContainer>
    </div>
  );
}

const query = graphql`
  query CSSettledTransactionListQuery (
    $first: Int
    $offset: Int
    $search: String
    $reportDate: Date
    $matched: Boolean
    $ignore: Boolean
  ) {
    viewer {
      ...CSSettledTransactionList_viewer
      @arguments (
        first: $first
        offset: $offset
        search: $search
        reportDate: $reportDate
        matched: $matched
        ignore: $ignore
      )
    }
  }
`;

const container = createRefetchContainer(
  CSSettledTransactionList,
  {
    viewer: graphql`
      fragment CSSettledTransactionList_viewer on Query
      @argumentDefinitions(
        first: {type: Int, defaultValue: 10}
        offset: {type: Int}
        search: {type: String}
        reportDate: {type: Date}
        matched: {type: Boolean}
        ignore: {type: Boolean}
      ) {
        clearstreamSettledTransactions(
          first: $first
          offset: $offset
          search: $search
          reportDate: $reportDate
          ignore: $ignore
          matched: $matched
          orderBy: "-createdAt"
        ) {
          edges {
            node {
              brokertransactionPtr {
                id
              }
              brokerOrder {
                id
                csbrokerorder {
                  id
                  transferAdviceFile {
                    id
                    csvUrl
                    csv
                  }
                }
              }
              id
              createdAt
              updatedAt
              reportDate
              matched
              ignore
              price
              yourReference
              isin
              status
              settledAmount
              proceeds
              quantity
              currency 
            }
          }
          count
        }
      }
    `,
  },
  query,
);

export default withRouter(createQueryRendererProgressV2(
  query,
  container,
  {},
  () => ({
    search: null,
    reportDate: null,
    matched: matchedDefault,
    ignore: ignoreDefault,
  }),
  {
    debounceFields: ['search'],
  },
));
